module.exports = __webpack_public_path__ + "dash_20_app_assets/img/reviewlogos.fe4cb086.png";